import { FC } from 'react';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';

import {
  BATCH_STATE_GROUP_CHIP_COLOURS,
  DEGRADED_CHIP_COLOUR,
  FALLBACK_CHIP_COLOUR,
} from 'src/constants/lottery/chipColours';
import {
  BATCH_STATE_GROUP_LABELS,
  BATCH_STATUS_DEGRADED,
  BATCH_STATUS_STARTING,
  humanizeEnumValue,
} from 'src/constants/lottery/statusLabels';
import { LotteryBatchStateGroup } from 'src/types/Lottery';
import { resolveChipColours } from './chipStyles';

export interface LotteryBatchStatusChipProps {
  stateGroup: LotteryBatchStateGroup;
  state?: string;
  degraded?: boolean;
  label?: string;
  onClick?: () => void;
}

export const LotteryBatchStatusChip: FC<LotteryBatchStatusChipProps> = ({
  stateGroup,
  state,
  degraded = false,
  label,
  onClick,
}) => {
  const theme = useTheme();

  let resolvedLabel = label;
  if (!resolvedLabel) {
    if (degraded) {
      resolvedLabel = BATCH_STATUS_DEGRADED;
    } else if (state === 'REQUESTED' || state === 'PULLING') {
      resolvedLabel = BATCH_STATUS_STARTING;
    } else {
      resolvedLabel =
        BATCH_STATE_GROUP_LABELS[stateGroup] ?? humanizeEnumValue(stateGroup);
    }
  }

  const mapped = BATCH_STATE_GROUP_CHIP_COLOURS[stateGroup];
  const colour = degraded
    ? DEGRADED_CHIP_COLOUR
    : mapped ?? FALLBACK_CHIP_COLOUR;

  return (
    <Chip
      label={resolvedLabel}
      size="small"
      aria-label={resolvedLabel}
      data-colour={!degraded && mapped ? 'mapped' : 'neutral'}
      onClick={onClick}
      sx={resolveChipColours(theme, colour)}
    />
  );
};

export default LotteryBatchStatusChip;
